import React, { useState } from 'react';
import HoverButton from '../../component/HoverButton';
import OurClientTallyserver from '../../component/OurClientTallyserver';
import PageLayout from '../../component/PageLayout';
import ProductTallyPrime from '../../component/Product-TallyPrime';
import IconArrowDown from '../../component/SvgIcons/IconArrowDown';
import IconRightArrow from '../../component/SvgIcons/IconRightArrow';
import IconTallyPrimelogo from '../../component/SvgIcons/IconTallyPrimelogo';
import IconTallyPrimeServerLogo from '../../component/SvgIcons/IconTallyPrimeServerLogo.js';
import './style.css';
import { faqData, tallyPrimeServerData } from './tallyPrimeServerData';

export default function TallyPrimeServer() {
  const [activeIndex, setActiveIndex] = useState(0);
  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
  return (
    <div className="TallyPrimebg twotab">      
      <PageLayout>
        <ProductTallyPrime />
        <section className="TabFirstTallyPrime-tab pt50 pb100">
          <div className="container">
            <div className="d-flex flex-column align-items-center primeserver gap50">
              <div className="innertablogo">
                <IconTallyPrimeServerLogo/>
              </div>
              <div className="gap50 d-flex mb100 flex-column flex-md-row align-items-center justify-content-between unleashmain">
                <div className="unleashmain-pic">
                  <img
                    src="../images/TallyPrimeServer/TallyPrime-Server.webp"
                    className="img-fluid"
                    alt="Tally Prime Server"
                    width="650"
                  />
                </div>

                <div className="unleashmain-info">
                  <h4>
                  What is TallyPrime Server?
                  </h4>
                  <p>
                  TallyPrime Server offers powerful data server capabilities over the Gold license. This server-based Data Architecture unleashes greater concurrency, secured data access, and advanced monitoring capabilities. TallyPrime Server is truly an Enterprise Class Product that helps fast-growing medium and large businesses improve their business efficiencies.
                  </p>
                  <div className="button d-flex gap50">
                    <a
                      href="../images/satup/TallyPrimeServer_setup6-0.exe"
                      download
                      className="btn btn-danger"
                    >
                      <label>
                        Download Now <IconRightArrow />
                      </label>
                      <span></span>
                    </a>
                    <HoverButton btnclassname="btn btn-dark" to="/contact">
                      <label>
                        Contact Us Now <IconRightArrow />
                      </label>
                    </HoverButton>
                  </div>
                </div>
              </div>
            </div>

            <div className="titletwo twotabintaly text-center titletwo">
              <h2>
              Key <span>features</span>
              </h2>           
            </div>

            {tallyPrimeServerData.map((item, index) => (
              <div
                className={`keyfeatures-main d-flex ${
                  item.reverse ? "flex-md-row-reverse" : ""
                } flex-column flex-md-row gap30`}
                key={index}
              >
                <div className="keyfeatures-picture box-default justify-content-center d-flex align-items-center">
                  <img src={item.img} alt={item.alt} />
                </div>
                <div className="keyfeatures-information box-default d-flex justify-content-center flex-column">
                  <h5>{item.title}</h5>
                  <p>
                    <strong>{item.strong}</strong>
                  </p>
                  <p>{item.description}</p>
                </div>
              </div>
            ))}           
          </div>

          <section className="faq-section">
          <div className="container"> 
            <div className='box-default'>
          <div className="titletwo twotabintaly text-center">
          <h2>Key benefits of <span>TallyPrime Server</span></h2>        
            </div>     
     
        <div className='benefits-main flex flex-col-reverse lg:flex-row justify-between gap-5'>
        <div className='benefits-faq flex-1'>
          {faqData.map((item, index) => (
            <div key={index} className="faq-item mb-2 overflow-hidden">
              <div
                className={`faq-question cursor-pointer transition ${
                  activeIndex === index ? "active" : ""
                }`}
              
                onClick={() => toggleFAQ(index)}
              >
                {item.question} <IconArrowDown/>
              </div>

              <div
                className={`faq-answer transition-all duration-300 ease-in-out overflow-hidden ${
                  activeIndex === index ? "p-3 bg-white" : "max-h-0 p-0"
                }`}
              >
                <p>{item.answer}</p>
              </div>
            </div>
          ))}
          </div>

            <div className='benefits-pic flex-1'>
            <img src='../images/TallyPrimeServer/capabilities.webp' className='img-fluid' alt='Key benefits of TallyPrime Server'/>
            </div>
        </div>
        </div>
      </div>
    </section>
            
          <OurClientTallyserver />
          <div className="container">
            <div className="tallypricebox-main d-flex justify-content-center">
              <div className="tallypricebox box-default goldcolor text-center">
                <div className="tallylogo">
                  <IconTallyPrimelogo />
                </div>
                <h4>Gold</h4>
                <p>
                  <span>
                  For medium and large enterprises
                  (Tally Server works with Tally Gold license)
                  </span>
                </p>
                <h1>$ 9,450</h1>
                <p>(+ Tax)</p>
                <div className="buybtn">
                  <HoverButton btnclassname="btn btn-purpal" to="/contact">
                    <label>                      
                      Buy Now <IconRightArrow />
                    </label>
                  </HoverButton>
                </div>
              </div>
            </div>
          </div>
        </section>
      </PageLayout>
    </div>
  );
}
